import React from 'react';
import { Tabs, Collapse } from 'antd';

const Faqs = () => {
    const { Panel } = Collapse;

    const onChange = (key: string | string[]) => {
        // console.log(key);
    };
    function gotous(): void {
        window.open('https://discord.gg/M2TaS3ZQhY')
    }

    function gotoApply(): void {
        window.open('https://forms.gle/rdL9JAQmq5EoV1AY9 ')
    }


    return (
        <>
            <style>
            {`
                .main-page-faqs a {
                    color: #1677ff !important;
                }
            `}
            </style>
            <div className="main-page-faqs">
                <div className="container">
                    <div className="wrap-faqs">
                        <div className="columns">
                            <div className="colum w-6">
                                <div className="guide-faqs">
                                    <div className="title">
                                        Frequently Asked Questions
                                    </div>
                                    <div className="desc">
                                        Can’t find an answer to your question?
                                        Feel free to <span onClick={gotous} className='c-us'>contact us</span>
                                    </div>
                                </div>
                            </div>
                            <div className="colum w-6">
                                <div className="tabs-faqs">
                                    <Tabs defaultActiveKey="item-1">
                                        <Tabs.TabPane tab="General" key="item-1">
                                            <div className="collaps-content">
                                                <Collapse defaultActiveKey={['1']} onChange={onChange}>
                                                    <Panel header="What is the TinyBlock?" key="1">
                                                        <p>TinyBlock is a Web3 launchpad for early-stage projects to raise funds and grow, while giving investors early access to token sales.                                                        </p>
                                                    </Panel>
                                                    <Panel header="What is an IDO?" key="2">
                                                        <p>An IDO (Initial DEX Offering) is a decentralized token sale where users can invest in a project’s token before it lists on public markets</p>
                                                    </Panel>
                                                    <Panel header="Which blockchain(s) does TinyBlock support?" key="3">
                                                        <p>You can check the supported blockchains on TinyBlock by clicking on the blockchain button at the right corner of our website.</p>
                                                    </Panel>
                                                    <Panel header="How to create an account on TinyBlock?" key="4">
                                                        <p>No sign-up is needed. Just connect your wallet to get started.</p>
                                                    </Panel>
                                                    <Panel header="Do I need KYC to use TinyBlock?" key="5">
                                                        <p>We're decentralized platform so KYC is no required on TinyBlock.</p>
                                                    </Panel>
                                                </Collapse>
                                            </div>
                                        </Tabs.TabPane>
                                        <Tabs.TabPane tab="For Investors" key="item-2">
                                            <div className="collaps-content">
                                                <Collapse defaultActiveKey={['6']} onChange={onChange}>
                                                    <Panel header="How can I participate in an IDO?" key="6">
                                                        <p>Follow the step-by-step guide on how to join an IDO on TinyBlock <a href=" https://docs.tinyblock.io/user-guide/how-to-participate-in-an-ido" target="_blank" rel="noopener noreferrer">HERE</a>.</p>
                                                    </Panel>
                                                    <Panel header="Is there a minimum investment amount?" key="7">
                                                        <p>Yes, and it varies by project. Details are shown on the IDO page's "Participate & Claim" section.</p>
                                                    </Panel>
                                                    <Panel header="What crypto tokens can be used to participate in IDOs?" key="8">
                                                        <p>Usually USDT, USDC, BNB, or ETH - depending on the project and chain.</p>
                                                    </Panel>
                                                    <Panel header="Is there a refund policy?" key="9">
                                                        <p>The refund policy depends on the project. Each project has its own refund policy, which is mentioned in the IDO page's "Project Info" section.                                                        </p>
                                                    </Panel>
                                                </Collapse>
                                            </div>
                                        </Tabs.TabPane>
                                        <Tabs.TabPane tab="For Projects" key="item-3">
                                            <div className="collaps-content">
                                                <Collapse defaultActiveKey={['10']} onChange={onChange}>
                                                    <Panel header="How do I launch my project on TinyBlock?" key="10">
                                                        <p>Submit your application through <a href=" https://forms.gle/rdL9JAQmq5EoV1AY9" target="_blank" rel="noopener noreferrer">this form</a>. Our team will review and get in touch.</p>
                                                    </Panel>
                                                    <Panel header="What kind of projects do you accept?" key="11">
                                                        <p>Builders from all sectors of the blockchain economy are invited to apply.</p>
                                                    </Panel>
                                                    <Panel header="Does TinyBlock provide marketing or advisory support?" key="12">
                                                        <p>Yes. We support with tokenomics, marketing, and community growth.</p>
                                                    </Panel>
                                                    <Panel header="Can we choose the blockchain for our token launch?" key="13">
                                                        <p>Yes. You can choose any supported chain based on your strategy.</p>
                                                    </Panel>
                                                </Collapse>
                                            </div>
                                        </Tabs.TabPane>
                                    </Tabs>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="wrap-launch-project">
                        <div className="launch-apps">
                            <div className="line-top">
                                <img src="/images/line-top.png" alt="" />
                            </div>
                            <div className="line-bot">
                                <img src="/images/line-bot.png" alt="" />
                            </div>
                            <div className="box-img-apps">
                                <img src="/images/img-apps.png" alt="" />
                            </div>
                            <div className="title-apps">
                                Launch your project on TinyBlock
                            </div>
                            <div className="main-desc-new">
                                Ready to blow up your IDO? Let’s get started!
                            </div>


                            <div className="gr-button">
                                <button className="main-button w-200" onClick={gotoApply}>
                                    Apply to launch
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Faqs